module.exports = __webpack_public_path__ + "img/04.2db88295.svg";